/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface PostByOrderidCancel$Params {
  OrderId: number;
}

export function postByOrderidCancel(
  http: HttpClient,
  rootUrl: string,
  params: PostByOrderidCancel$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, postByOrderidCancel.PATH, 'post');
  if (params) {
    rb.path('OrderId', params.OrderId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    }),
  );
}

postByOrderidCancel.PATH = '/Orders/{OrderId}/cancel';
